import * as React from 'react';
import Card from './TeamCardComponent';

const Team = () => {
    return(
        <div id="equipe">
            <div className="container-fluid col-sm-12 team-f-block align-items-center text-center">
                <div className="container col-sm-3 col-md-5">
                    <h2 className="bold roxo-e">EQUIPE</h2>
                </div>
                <div className="container col-sm-6 col-md-8">
                    <h3>
                        Conte conosco para criar e construir os produtos para suas necessidades e de seus clientes, juntos
                    </h3>
                </div>
                <div className="container-fluid col-sm-12 col-md-12 col-lg-8 cards">
                    <Card
                    nome="Rodrigo Freitas" cargo="Fundador e Diretor Executivo" foto={require("../css/img/rod.jpg")}
                    linkedin="https://www.linkedin.com/in/rodrigosalustianodefreitas/"
                    />
                    <Card
                    nome="Guilherme Sakajiri" cargo="Co-fundador" foto={require("../css/img/saka.png")}
                    linkedin="https://www.linkedin.com/in/guilhermesakajiri/"
                    />
                    <Card
                    nome="Caio Saldanha" cargo="Desenvolvedor Full-Stack" foto={require("../css/img/caio.png")}
                    linkedin="https://www.linkedin.com/in/zscaiosisaldanha/"
                    />
                    <Card
                    nome="Joedson Santos" cargo="Estagiário em Desenvolvimento" foto={require("../css/img/joedson.jpg")}
                    linkedin="https://www.linkedin.com/in/joedson-s-b558a8a4/"
                    />
                    <Card
                    nome="Silvio Freitas" cargo="Finance" foto={require("../css/img/silvio.jpg")}
                    linkedin="https://www.linkedin.com/in/silvio-freitas-a9488b22/"
                    />
                    <Card
                    nome="Erich Lotto" cargo="Desenvolvedor Android" foto={require("../css/img/erich.jpg")}
                    linkedin="https://www.linkedin.com/in/erichlotto/"
                    />
                </div>
            </div>
        </div>
    );
};
export default Team;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/TeamComponent.tsx